import React from "react";
import "../../Styles/Ashnai.css";

const Ashnai = ({ AshnaiList, selectedOption, setSelectedOption, setAshnaiValue, close }) => {
    return (
            <div className="modal-wrapper mobile-bottom">
                <div className="Ashnai">
                    <div className="Ashnai-inside">
                        <div className="Ashnai-inside-top">
                            <div className="Ashnai-inside-top-text">
                                <p className="Ashnai-inside-top-text-p">
                                    نحوه آشنایی
                                </p>
                            </div>

                            <div className="Ashnai-inside-top-image" onClick={close}>
                                <img className="Ashnai-inside-top-image-img" src="imgs/Profile/editProfile.svg" />
                            </div>

                        </div>
                        <div className="Ashnai-inside-center">
                            <ul className="Ashnai-inside-center-ul">
                                {AshnaiList?.options?.map((item, i) => (
                                    <li key={item.id}>
                                        <input
                                            type="radio"
                                            hidden
                                            id={item.id}
                                            onChange={() => setSelectedOption(item)}
                                            checked={selectedOption?.id == item.id}
                                            name="answer"
                                            className="Ashnai-inside-center-ul-Option-input"
                                            value={item.id}
                                        />
                                        <label
                                            htmlFor={item.id}
                                            className="Ashnai-inside-center-ul-Option-label">
                                            <div className="Ashnai-inside-center-ul-Option-label-inside">
                                                <div className="Ashnai-inside-center-ul-Option-label-inside-inside-circle">
                                                    <svg height="40" width="40">
                                                        <circle
                                                            cx="20"
                                                            cy="20"
                                                            r="10"
                                                            className="circle"
                                                        />
                                                    </svg>
                                                </div>
                                                <p className="Ashnai-inside-center-ul-Option-label-inside-insid-text">
                                                    {item.name}
                                                </p>
                                            </div>
                                        </label>
                                    </li>
                                ))}

                            </ul>
                        </div>

                        <div className="Ashnai-inside-bottom">
                            <input
                                onClick={() => {
                                    setAshnaiValue(selectedOption)
                                    close()
                                }}
                                className="Ashnai-inside-bottom-submit"
                                type="submit"
                                value="ثبت" />
                        </div>

                    </div>

                </div>
            </div>
    )
}
export default Ashnai;